// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3lzkF","title":"ClientInsurance_title__2f72A","itemText":"ClientInsurance_itemText__27I3b"};